import { render, staticRenderFns } from "./ScribeSync.vue?vue&type=template&id=60e08e95&"
import script from "./ScribeSync.vue?vue&type=script&lang=ts&"
export * from "./ScribeSync.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports